import TabViewComponent from './TabView';

const TabView = TabViewComponent;

export default TabView;